import * as Types from '../generated.types'

export type FinchConnectionDetailFragment = {
  __typename: 'FinchConnection'
  id: number
  sessionId?: string | null
  displayLabel?: string | null
  isActive: boolean
  status?: Types.FinchConnectionStatus | null
  hasAuthenticatedEver: boolean
}

export const FinchConnectionDetailFragmentDoc = `
    fragment FinchConnectionDetail on FinchConnection {
  __typename
  id
  sessionId
  displayLabel
  isActive
  status
  hasAuthenticatedEver
}
    `
